export default __webpack_public_path__ + "static/0182-91f1cd3e238d94f1c540b9a8a0ab2423.png";